import type { Location } from 'react-router-dom';

const LAST_FLOOR_PLAN_RETURN_URL_KEY = 'vfloow:lastFloorPlanReturnUrl';

type ReturnLocationState = {
  from?: string;
};

type NavigationReturnOptions = {
  allowLastFloorPlanFallback?: boolean;
};

export function buildFloorPlanReturnUrl(floorPlanId: string): string {
  return `/floor-plan?id=${encodeURIComponent(floorPlanId)}`;
}

export function rememberFloorPlanReturnUrl(floorPlanId: string): void {
  if (typeof window === 'undefined' || !floorPlanId) return;
  window.sessionStorage.setItem(
    LAST_FLOOR_PLAN_RETURN_URL_KEY,
    buildFloorPlanReturnUrl(floorPlanId),
  );
}

export function getNavigationReturnUrl(
  location: Location,
  fallback = '/dashboard',
  options: NavigationReturnOptions = {},
): string {
  const state = location.state as ReturnLocationState | null;
  if (state?.from) return state.from;

  if (typeof window === 'undefined') return fallback;
  if (options.allowLastFloorPlanFallback) {
    return window.sessionStorage.getItem(LAST_FLOOR_PLAN_RETURN_URL_KEY) || fallback;
  }

  return fallback;
}
